// extracted by mini-css-extract-plugin
export default {"pdoModels":"PDXO_pdoModels__wl507","PDOnumber":"PDXO_PDOnumber__9xJu+","title":"PDXO_title__exX+C","plusImg":"PDXO_plusImg__-RRce","minusImg":"PDXO_minusImg__ry-iy"};